module.exports = __webpack_public_path__ + "img/brooke-cagle-wKOKidNT14w-unsplash.5ee5ba54.jpg";